import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  quoteGroupDotted: {
    border: '1px dashed #C0C0CF',
    borderRadius: '4px',
    width: 'auto',
    marginBottom: '12px',
    padding: '10px 10px',
    tableLayout: 'auto',
    overflowX: 'auto',
    '@media screen and (max-width: 768px)': {
      margin: '15px',
      padding: '15px',
    },
    '& .MuiAutocomplete-popupIndicator': {
      marginRight: '-8px'
    },
    '& .MuiSelect-icon': {
      right: '0'
    },

  },
  packagesTableRoot: {
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '500px',
      overflowX: 'auto',
      margin: 0
    },

    '& .MuiTableCell-root': {
      padding: '4px 10px',
      borderColor: '#F6F6F9'
    },
    '& .MuiTableCell-root:last-child': {
      textAlign: 'right',
    },
    '& .MuiTableCell-head': {
      color: '#666687',
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'uppercase',
    }
  }
}));
